import { render, staticRenderFns } from "./FCCPasswordReset.vue?vue&type=template&id=bddb8318"
import script from "./FCCPasswordReset.vue?vue&type=script&lang=js"
export * from "./FCCPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports